import styled from "styled-components";
import { Modal } from "components/Modal";

export const TransactionModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 560px;

    .modal-content {
      padding: 0;
      border-radius: 16px;

      .modal-body {
        padding: 0;
        margin-top: 0;

        .modal-header {
          padding: 20px 24px;
          border-bottom: 1px solid ${({ theme }) => theme.input.border.color};

          .modal-title {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            color: #181d27;
            font-family: "Geist", sans-serif;
          }
        }

        .modal-body-content {
          padding: 24px;

          .balance-section {
            margin-bottom: 24px;
            padding: 16px 20px;
            background: #fafafa;
            border-radius: 12px;

            .balance-label {
              font-size: 14px;
              font-weight: 400;
              color: #535862;
              margin-bottom: 8px;
              font-family: "Geist", sans-serif;
            }

            .balance-amount {
              font-size: 16px;
              font-weight: 500;
              color: #181d27;
              margin: 0;
              font-family: "Geist", sans-serif;
            }
          }

          .transaction-input-section {
            margin-bottom: 24px;

            .input-label {
              font-size: 14px;
              font-weight: 500;
              color: rgba(10, 13, 18, 0.7);
              margin-bottom: 8px;
              display: block;
              font-family: "Geist", sans-serif;
            }

            .input-wrapper {
              display: flex;
              align-items: center;
              gap: 8px;

              .amount-input {
                flex: 1;
                padding: 10px 14px;
                font-size: 16px;
                border: 1px solid #d5d7da;
                border-radius: 8px;
                background: #ffffff;
                color: #111827;
                font-family: "Geist", sans-serif;

                &:focus {
                  outline: none;
                  border-color: #048af5;
                  box-shadow: 0 0 0 3px rgba(4, 138, 245, 0.1);
                }

                &::placeholder {
                  color: #9ca3af;
                }

                &.error {
                  border-color: #ef4444;

                  &:focus {
                    border-color: #ef4444;
                    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
                  }
                }
              }

              .currency-label {
                padding: 10px 16px;
                background: #f9fafb;
                border: 1px solid #d5d7da;
                border-radius: 8px;
                font-size: 14px;
                font-weight: 500;
                color: #6b7280;
                font-family: "Geist", sans-serif;
              }
            }

            .error-message {
              margin-top: 8px;
              font-size: 13px;
              font-weight: 400;
              color: #ef4444;
              font-family: "Geist", sans-serif;
              line-height: 1.4;
            }
          }

          .bank-details-section {
            margin-bottom: 24px;
            background: #fafafa;
            border-radius: 12px;

            .bank-details-content {
              padding: 16px;
            }

            .section-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 16px;
              padding: 16px;
              border-bottom: 1px solid #e5e7eb;

              .section-title {
                font-size: 14px;
                font-weight: 500;
                color: #717680;
                margin: 0;
                font-family: "Geist", sans-serif;
              }

              .update-button {
                padding: 6px 16px;
                background: #ffffff;
                border: 1px solid #d5d7da;
                border-radius: 6px;
                font-size: 14px;
                font-weight: 500;
                color: #374151;
                cursor: pointer;
                transition: all 0.2s ease;
                font-family: "Geist", sans-serif;

                &:hover {
                  background: #f9fafb;
                }

                &:disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }

            .bank-detail-row {
              margin-bottom: 16px;
              display: flex;
              justify-content: space-between;
              align-items: center;

              &:last-child {
                margin-bottom: 0;
              }

              .detail-label {
                font-size: 16px;
                font-weight: 400;
                color: rgba(10, 13, 18, 0.6);
                margin-bottom: 4px;
                font-family: "Geist", sans-serif;
              }

              .detail-value {
                font-size: 14px;
                font-weight: 500;
                color: #000;
                margin: 0;
                font-family: "Geist", sans-serif;
              }
            }
          }

          .action-button {
            width: 100%;
            padding: 12px;
            background: #2563eb;
            border: none;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            cursor: pointer;
            transition: all 0.2s ease;
            font-family: "Geist", sans-serif;

            &:hover {
              background: #1d4ed8;
            }

            &:disabled {
              background: #9ca3af;
              cursor: not-allowed;
            }
          }

          .loader-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 40px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;

      .modal-content {
        .modal-body {
          .modal-header {
            padding: 16px 20px;

            .modal-title {
              font-size: 16px;
            }
          }

          .modal-body-content {
            padding: 20px;

            .balance-section {
              .balance-amount {
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }
`;
